import { Stack, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import Text from '../text';
import Icon from '../icon';
import useDrawer from '@/hooks/use-drawer.hook';
import DrawerMenu from '@/components/drawers/menu';

interface Props {
  children: ReactNode;
  onClose: () => void;
  menu?: ReactNode;
  isTopDrawer?: boolean;
}

const useStyles = createUseStyles((theme: Theme) => ({
  header: {
    padding: '0px 20px 12px 20px',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  icon: {
    padding: 2,
    '&:hover': {
      backgroundColor: theme.palette.lightGray,
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

const DrawerHeader: FC<Props> = ({ children, onClose, menu, isTopDrawer = false }) => {
  const styles = useStyles();
  const { goBackDrawer } = useDrawer();

  const handleBack = () => {
    goBackDrawer();
  };

  const hasMenu = !!menu;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      className={styles.header}
    >
      <Stack maxWidth={450} direction="row" alignItems="center" gap={1}>
        {isTopDrawer && <Icon name="arrow-left" onClick={() => handleBack()} />}
        <Text size="large" dotdot>
          {children}
        </Text>
      </Stack>
      <Stack direction="row" alignItems="center" gap={1}>
        {hasMenu ? menu : <DrawerMenu />}
        <Icon name="close" onClick={() => onClose()} className={styles.icon} />
      </Stack>
    </Stack>
  );
};

export default DrawerHeader;
